import {
  METRIC_ACCURACY,
  METRIC_NO_SHOW,
  METRIC_WORKSTATION,
  METRIC_EFFICIENCY,
  METRIC_UTILISATION_UTILISATION,
  METRIC_UTILISATION_BOOKED,
  METRIC_UTILISATION_NO_SHOW,
  METRIC_UTILISATION_GHOST
} from "./metrics";

export const METRIC_CONFIG = {
  [METRIC_ACCURACY]: {
    label: "Accuracy",
    color: "#00d4ff"
  },
  [METRIC_NO_SHOW]: {
    label: "No Show",
    color: "#ff4d4f"
  },
  [METRIC_WORKSTATION]: {
    label: "Workstation",
    color: "#52c41a"
  },
  [METRIC_EFFICIENCY]: {
    label: "Efficiency",
    color: "#722ed1"
  }
};


export const METRIC_UTILISATION_CONFIG = {

    [METRIC_UTILISATION_UTILISATION]: {
        label: "Utilisation",
        color: "#5a9bd6",
        description:
            "Actual observed utilisation based on occupancy and activity."
    },

    [METRIC_UTILISATION_BOOKED]: {
        label: "Booked",
        color: "#f59e0b",
        description:
            "Percentage of room capacity booked through the booking system."
    },

    [METRIC_UTILISATION_NO_SHOW]: {
        label: "No Show",
        color: "#ef4444",
        description:
            "Bookings where rooms were reserved but showed little or no occupancy."
    },

    [METRIC_UTILISATION_GHOST]: {
        label: "Ghost Bookings",
        color: "#8b5cf6",
        description:
            "Suspicious bookings where rooms remained largely unused despite being reserved."
    }
};